// export const baseURL = "https://cnp1837-api.developer24x7.com/"; //development
// export const baseURL = "http://ec2-15-206-166-155.ap-south-1.compute.amazonaws.com:4000/";
export const baseURL = "http://localhost:3010/";
export const imagePath = baseURL + "categoryImages/";

